import { Component, OnInit } from '@angular/core';
import { VOLUME_DISCOUNT_UNITS, MERCHANT_TYPE, PAYMENT_TYPE, USER_ROLES } from '../../../../enums';
import { VolumeDiscountRateRequestApi } from '../../../../../assets/js/lb-sdk/services/custom/VolumeDiscountRateRequest';
import { BsModalService } from 'ngx-bootstrap';
import { ProductsService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';
import { BasicList } from '../../../../classes';
import { Event } from '../../../../interfaces';
import { AgentProfileComponent } from '../../../agents/agent-profile/agent-profile.component';
import { VolumeDiscountRateRequestFormComponent } from './volume-discount-rate-request-form/volume-discount-rate-request-form.component';
import { finalize } from 'rxjs/operators';
import { LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { HasRolePipe } from '../../../../pipes/has-role.pipe';

@Component({
  selector: 'app-volume-discount-rate-requests',
  templateUrl: './volume-discount-rate-requests.component.html',
  styleUrls: ['./volume-discount-rate-requests.component.css']
})
export class VolumeDiscountRateRequestsComponent extends BasicList {
  VOLUME_DISCOUNT_UNITS: typeof VOLUME_DISCOUNT_UNITS = VOLUME_DISCOUNT_UNITS;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;

  constructor(
    private volumeDiscountRateRequestApi: VolumeDiscountRateRequestApi,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService,
    private hasRolePipe: HasRolePipe,
    public productsService: ProductsService,
    private toast: ToastrService
  ) {
    super();
    if (this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.ALTERNATIVE_CHANNEL)) {
      this.params = {
        where: { requestor: this.getUser().id }
      };
    } else if (this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.BDM)) {
      this.params = {
        include: 'user'
      };
    }
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'partnerId', placeholder: 'Merchant Id' },
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'merchantType', placeholder: 'Merchant Type', options: MERCHANT_TYPE },
        { name: 'paymentType', placeholder: 'Payment Type', options: PAYMENT_TYPE }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: VolumeDiscountRateRequestFormComponent,
      api: this.volumeDiscountRateRequestApi,
      ModalService: this.modalService
    };
  }

  modify(data) {
    const { id, partnerId, productType, merchantType, paymentType, unit, minimum, discount } = data;
    this.edit({
      id,
      partnerId: partnerId,
      productType: this.productsService.getProductTypeByName(productType),
      merchantType,
      paymentType,
      discount,
      unit,
      minimum
    });
  }

  approve(request) {
    this.loading.approval = true;
    this.clearErrors();
    this.volumeDiscountRateRequestApi
      .approve(request.id)
      .pipe(finalize(() => {
        this.loading.approval = false;
      }))
      .subscribe((response: any) => {
        this.toast.success('Request Approved!');
        this.getList();
      }, error => {
        this.errors.approval = error.message.indexOf('Unique combination') >= 0 ?
          'Already have a volume discount rate for the product' :
          (error.message || 'Failed to create approve volume discount rate request.');
      });
  }

  userDetails(data): void {
    const userModal = this.settings.ModalService
      .show(AgentProfileComponent, {
        initialState: { data: { merchantId: data.partnerId } }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (userModal.content) {
          if (userModal.content.result) {
            // DO SOMETHING
          } else {
            // DO SOMETHING
          }
        }
        subscription.unsubscribe();
      });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Volume discount rate request successfully submitted', 'Volume Discount Rate Request');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Volume discount rate request successfully updated', 'Volume Discount Rate Request');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Volume discount rate request successfully deleted', 'Volume Discount Rate Request');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
